import { MenuTypes } from '@/models/Menu/Constants';
import { GeoTargetingMenuSettingFormModel, TemporaryNewspaperMenuSettingFormModel, TemporaryRetargetingMenuSettingFormModel, TemporaryCustomGeoMenuSettingFormModel, TemporaryPTAMenuSettingFormModel, TemporaryGeoGenomeMenuSettingFormModel, TemporaryCustomMenuSettingFormModel, TemporaryAutomobileMenuSettingFormModel, TemporaryMansionMenuSettingFormModel, TemporaryOfficeMenuSettingFormModel, TemporaryRailwayMenuSettingFormModel, } from '.';
export var factoryMenuSettingForm = function (profileIds, menuType, menuSetting) {
    switch (menuType) {
        case MenuTypes.Geo:
            return new GeoTargetingMenuSettingFormModel(menuSetting, profileIds);
        case MenuTypes.Automobile:
            return new TemporaryAutomobileMenuSettingFormModel(menuSetting);
        case MenuTypes.Mansion:
            return new TemporaryMansionMenuSettingFormModel(menuSetting);
        case MenuTypes.Newspaper:
            return new TemporaryNewspaperMenuSettingFormModel(menuSetting);
        case MenuTypes.Retargeting:
            return new TemporaryRetargetingMenuSettingFormModel(menuSetting);
        case MenuTypes.CustomGeo:
            return new TemporaryCustomGeoMenuSettingFormModel(menuSetting);
        case MenuTypes.Pta:
            return new TemporaryPTAMenuSettingFormModel(menuSetting);
        case MenuTypes.GeoGenome:
            return new TemporaryGeoGenomeMenuSettingFormModel(menuSetting);
        case MenuTypes.Custom:
            return new TemporaryCustomMenuSettingFormModel(menuSetting);
        case MenuTypes.Office:
            return new TemporaryOfficeMenuSettingFormModel(menuSetting);
        case MenuTypes.Railway:
            return new TemporaryRailwayMenuSettingFormModel(menuSetting);
        default:
            return new GeoTargetingMenuSettingFormModel(menuSetting, profileIds);
    }
};
export default factoryMenuSettingForm;
